import type { FC } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type TabSelectorProps = {
  choices: Array<{ label: string; value: string }>;
  selectedTab: string;
  setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
};

const TabSelector: FC<TabSelectorProps> = ({
  choices,
  selectedTab,
  setSelectedTab,
}) => {
  return (
    <div className="flex flex-col p-[2px]">
      {choices.map((choice) => {
        return (
          <Button
            type="button"
            key={`tab-${choice.value.toLowerCase()}`}
            variant={"outline"}
            className={cn([
              "items-left justify-start py-2 px-3 border-none",
              choice.value === selectedTab ? "bg-gray-50" : "bg-white",
            ])}
            onClick={() => setSelectedTab(choice.value)}
          >
            {choice.label}
          </Button>
        );
      })}
    </div>
  );
};

export default TabSelector;
